module.exports = __webpack_public_path__ + "static/img/2.666cd31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/2.png
// module id = tsXl
// module chunks = 0